import { render, staticRenderFns } from "./ShamlPersonalInfo.vue?vue&type=template&id=4db4b9ec&"
import script from "./ShamlPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./ShamlPersonalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports